import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { LogoutConfig } from '@hdms/shared/data-access';
import { TranslationModule } from '@hdms/shared/feature';
import { UserAccount } from '@hdms/shared/page-frame/types';
import { HeaderUIUserModule } from '@hdms/shared/page-frame/ui';
import { ButtonModule, IconsName, SvgIconModule } from '@hdms/shared/ui-core';

import { HeaderUserLogoutComponent } from '../header-user-logout/header-user-logout.component';

@Component({
  standalone: true,
  selector: 'shrd-pf-ft-header-user-account-wrapper',
  templateUrl: './header-user-account-wrapper.component.html',
  styleUrls: ['./header-user-account-wrapper.component.scss'],
  imports: [
    CommonModule,
    SvgIconModule,
    TranslationModule,
    ButtonModule,
    HeaderUIUserModule,
    HeaderUserLogoutComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderUserAccountWrapperComponent {
  readonly iconSet = IconsName;
  showAccountList = false;

  @Input() userAccount: UserAccount;
  @Input() omitUserTitle = false;
  @Input() logoutConfig: LogoutConfig;
  @Input() canSwitchAccount: boolean;

  @Output() toggleAccountSelection = new EventEmitter<boolean>();

  onToggleAccountSelection(showAccountListView: boolean): void {
    this.showAccountList = showAccountListView;
    this.toggleAccountSelection.emit(this.showAccountList);
  }
}
